import styled from "styled-components";
import { ITag } from "./index";
import { NavLink } from "react-router-dom";
const FooterTag = (props: ITag) => {
    const { Icon, IconDark, text, link, active } = props;
    return (
        <StyledNavLink to={link} className={active ? "active" : ""}>
            <div className="imageDiv">
                <img src={active ? IconDark : Icon} alt={text} className="footer-icon" />
            </div>
            <span>{text}</span>
        </StyledNavLink>
    );
};
const StyledNavLink = styled(NavLink)`
    display: flex;
    width: 100%;
    font-size: 12.5px;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    text-decoration: none;
    transition: background-color 0.3s ease;
    .imageDiv {
        width: 19px;
        height: 19px;
    }
    img {
        width: 100%;
        height: 100%;
    }
    span {
        margin-top: 8px;
        color: #898d8f;
    }
    &.active {
        span {
            color: #37445d;
            font-weight: 700;
        }
    }
    &:hover {
        background-color: #e0e0e0;
    }
`;
export default FooterTag;
